import { useState } from 'react'

/**
 * Very basic reusable state management for modal dialogues. Just open and close
 * callbacks and an isModalOpen boolean
 */
const useSimpleModalState = () => {
  const [isModalOpen, setIsModalOpen] = useState(false)

  const openModal = () => setIsModalOpen(true)
  const closeModal = () => setIsModalOpen(false)

  return {
    isModalOpen,
    openModal,
    closeModal,
  }
}

export default useSimpleModalState
